module.exports = __webpack_public_path__ + "img/product-placeholder-57.dc1fcc3.png";